import { StyleSheet } from 'react-native';
import { heightPercentageToDP as hp } from 'react-native-responsive-screen';

export const styles = StyleSheet.create({
  commerceItemContainer: {
    zIndex: 0,
  },
  textCommerceName: {
    fontSize: 14,
    fontWeight: '600',
    textAlign: 'left',
    lineHeight: 24,
    letterSpacing: 0,
    color: '#FFFFFF',
  },
  textCommerceAmountSold: {
    fontSize: 14,
    fontWeight: '600',
    textAlign: 'left',
    lineHeight: 24,
    letterSpacing: 0,
    color: '#FFFFFF',
  },
  cardItemLarge: {
    width: '95%',
    marginTop: 15,
    backgroundColor: '#f3f3f323',
    paddingTop: 10,
    paddingBottom: 10,
    flexDirection: 'row',
    alignSelf: 'center',
    justifyContent: 'space-evenly',
    borderRadius: 12,
  },
  cardCommerceItemLarge: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignSelf: 'center',
    alignItems: 'center',
    paddingVertical: 15,
    paddingRight: 24,
    paddingLeft: 99,
    height: hp('50%'),
    width: '90%',
    marginTop: 15,
    backgroundColor: '#001C47',
    paddingBottom: 10,
    borderRadius: 5,
  },
  cardCommerceItemSmall: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignSelf: 'center',
    alignItems: 'center',
    paddingVertical: 8,
    paddingRight: 24,
    paddingLeft: 16,
    height: hp('10%'),
    width: '90%',
    marginTop: 5,
    backgroundColor: '#001C47',
    paddingBottom: 10,
    borderRadius: 5,
  },
  switchContainer: {
    alignSelf: 'center',
    marginTop: 15,
    width: '15%',
  },
  controlQuantityContainer: {
    flex: 0.2,
    flexDirection: 'row',
    alignSelf: 'flex-end',
    width: '50%',
    marginRight: 15,
  },
  productNameContainer: {
    alignSelf: 'flex-start',
  },
  iconDefault: {
    marginTop: 2,
    alignSelf: 'center',
    color: '#0F6657',
  },
  containerIcon: {
    backgroundColor: '#fff',
    borderRadius: 15,
    width: 35,
    height: 35,
  },
  cloverPointStatusChipContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: 5,
  },

  cloverPointStatusFirstChipContainer: {
    borderTopStartRadius: 10,
    borderBottomStartRadius: 10,
  },

  cloverPointStatusLastChipContainer: {
    borderTopEndRadius: 10,
    borderBottomEndRadius: 10,
  },
  
  cloverPointStatusText: {
    fontSize: 16, 
    fontWeight: 'bold',
    marginLeft: 5 
  },
});
